<!--
  ~ Copyright 2022-2024 Aion Technology LLC
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~     http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="footer">
  <div class="contact">
    <table>
      <thead class="mat-display-3">
        <tr>
          <td>ORGANIZATION</td>
          <td>CONTACT</td>
        </tr>
      </thead>
      <tbody class="mat-display-4">
      <tr>
        <td><a href="https://inspiresuccesskids.com" target="_blank">About Us</a></td>
        <td><a href="mailto:dale.baugh@theliveyourdreamfoundation.org">Contact Us</a></td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="mat-display4 copyright">
    <p>Copyright © 2025 - The Live Your Dream Foundation</p>
    <p>Created by <a href="https://aiontechnology.io" target="_blank"> Aion Technology, LLC</a></p>
  </div>
</div>
